import { render, staticRenderFns } from "./CreateOrderSuccessModal.vue?vue&type=template&id=008ed048"
import script from "./CreateOrderSuccessModal.vue?vue&type=script&lang=js"
export * from "./CreateOrderSuccessModal.vue?vue&type=script&lang=js"
import style0 from "./CreateOrderSuccessModal.vue?vue&type=style&index=0&id=008ed048&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('008ed048')) {
      api.createRecord('008ed048', component.options)
    } else {
      api.reload('008ed048', component.options)
    }
    module.hot.accept("./CreateOrderSuccessModal.vue?vue&type=template&id=008ed048", function () {
      api.rerender('008ed048', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PaymentOrder/PaymentOrder/CreateOrderSuccessModal.vue"
export default component.exports